import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../../utils/rel';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        other: PropTypes.object,
        index: PropTypes.number,
    };

    onClickNext = () => {
        const { other } = this.props;
        const { type, len, onArrow } = other;

        if (type + 1 >= len) {
            onArrow(0);
        } else {
            onArrow(type + 1);
        }
    };

    onClickPre = () => {
        const { other } = this.props;
        const { type, len, onArrow } = other;

        if (type - 1 < 0) {
            onArrow(len - 1);
        } else {
            onArrow(type - 1);
        }
    };

    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content, other, index } = this.props;
        const { showArrow, type } = other;

        const data = Array.isArray(content) && content.length > 0 && content[0];

        return (
            <div className={type === index ? styles.slideItem : styles.none}>
                <a href={data.url} target="_blank" alt={data.title} title={data.title} rel={rel} data-nomask>
                    <img src={data.thumbnail} style={{ width: 360, height: 220 }} />
                </a>
                <div className={styles.FosPicConTxt}>
                    <a
                        className={styles.FosPicConTxtA}
                        href={data.url}
                        target="_blank"
                        alt={data.title}
                        title={data.title}
                        rel={rel}
                        data-innermask>
                        {data.title}
                    </a>
                </div>
                {showArrow && (
                    <a className={`${styles.pre} ${styles.arrow}`} onClick={this.onClickPre}>
                        &lt;
                    </a>
                )}
                {showArrow && (
                    <a className={`${styles.next} ${styles.arrow}`} onClick={this.onClickNext}>
                        &gt;
                    </a>
                )}
            </div>
        );
    }
}

export default errorBoundary(Content);
